import { ProjectMappingDto, ProjectTransferResponseDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RecentProjectTransferResponseDto } from "./recent-project-transfer-response.dto";
import { EmployeeProjectsResponseDto } from "./employee-projects-response-dto";

export class ProjectMappingResponseModel extends GlobalResponseObject{
    data?: ProjectMappingDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ProjectMappingDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        // this.data = data;
    }
}

export class AllProjectMappingResponseModel extends GlobalResponseObject{
    data?: ProjectMappingDto[];
}

export class ProjectMappingResponseObject extends GlobalResponseObject{
    data?: ProjectMappingDto[];
}

export class ProjectMappingResponseName extends GlobalResponseObject{
    data?: projectNames[];
}

export class projectNames {
    projectName: string;
}
export class ProjectTransferResponseObject extends GlobalResponseObject{
    data?:ProjectTransferResponseDto[];
}
export class RecentProjectTransferResponseObject extends GlobalResponseObject{
    data?:RecentProjectTransferResponseDto[];
}
export class EmployeeProjectsResponseObject extends GlobalResponseObject{
    data?:EmployeeProjectsResponseDto[];
}